<template>
  <div class="search-bar">
    <div class="search-bar-input">
      <span style="margin: 7px;width: 50px">{{ $t('Partners.search') }}</span>
      <el-input v-model="inputVal" no="1" @input="(val)=>handleSearch('input',val)" />
      <el-button no="2" style="height: 28px;" type="primary" @click="()=>handleSearch('refresh')">{{ $t('FileHistory.Refresh') }}</el-button>
    </div>
    <div v-if="showFormItem" class="search-bar-form-item">
      <el-radio-group v-model="dateRange" no="3" @change="(val)=>handleSearch('range',val)">
        <el-radio :label="7">{{ $t('SeaExport.NearlyAWeek') }}</el-radio>
        <el-radio :label="30">{{ $t('SeaExport.NearlyAMonth') }}</el-radio>
        <el-radio :label="90">{{ $t('SeaExport.NearlyThreeMonths') }}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    showFormItem: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dateRange: 7,
      inputVal: ''
    }
  },
  methods: {
    handleSearch(type, val) {
      let value = val || null
      if (type === 'range' && !this.showFormItem) {
        return
      }
      if (type === 'refresh' && this.showFormItem) {
        value = this.dateRange
      }
      this.$emit('change', { type, value })
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking{
  .search-bar{
    display: flex;
    position: relative;
    margin: 5px;
    &-input{
      display: inline-flex;
      span{
        width: 40px;
      }
      .el-button{
        margin-left: 5px;
      }
    }
    &-form-item{
      margin: 7px;
      padding-left: 30px;
    }
  }
}
</style>
